$(function(){
	//�^�u�؂��ւ�
	$('#summary_nav a[href^="#summary"]').click(function(){
		$("#summary_content .panel").hide();
		$(this.hash).fadeIn();
		$('#summary_nav a').removeClass("is-current");
		$(this).addClass("is-current");
		
		return false;
	});
	$('#summay_nav a[href^="#summary"]:eq(0)').trigger('click');

});

